export default "__VITE_ASSET__DnLaur3r__"